import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';

export const API_DOMAIN: EndPointsNames = 'ApiLiferay';
export const ENDPOINT_API_PATH =
  '/o/headless-delivery/v1.0/sites/20124/structured-contents';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN = '#';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};
